<template>
  <div class="page-container-summary">
    <LandingBar active="help" />
    <div class="buy-wrapper">
      <v-breadcrumbs :items="bread" divider=">"></v-breadcrumbs>
      <div class="summary-upper">
        <div class="summary-left">
          <h1 class="table-headline">Support</h1>
          <div class="help-subheadline">
            We are here to help you. Please fill in the form below if you have
            any questions and we’ll get back to you soon.
          </div>
          <div class="balance-flex support-form">
            <label for="name">Name</label>
            <input
              v-validate="'required|email|max:50'"
              type="text"
              class="bottom-margin2"
              name="name"
            />
            <label for="email">Email</label>
            <input
              v-validate="'required|email|max:50'"
              type="email"
              class="bottom-margin2"
              name="email"
            />
            <label for="text">Message</label>
            <textarea
              rows="6"
              v-validate="'required|email|max:50'"
              type="email"
              class="bottom-margin2"
              name="text"
            />
            <v-btn elevation="2" color="#59c26b" class="help-button">
              Send</v-btn
            >
          </div>
        </div>
        <div class="summary-right">
          <v-btn elevation="2" color="#59c26b" class="transfer-button">
            Download manual instruction</v-btn
          >
          <div class="chatbox">
            <div class="chatbox-text">Start conversation with our chatbot</div>
            <v-btn elevation="2" color="#59c26b" class="help-button">
              Start chat</v-btn
            >
          </div>
          <v-row class="divider-row">
            <v-divider></v-divider><span class="divider-text">or</span
            ><v-divider></v-divider>
          </v-row>
          <div class="contact-wrapper">
            <div class="contact-headline">Contact us</div>
            <div class="contact-bold">Email</div>
            <div class="contact-sub green-text">it@emaxgroup.eu</div>
            <div class="contact-bold">Phone</div>
            <div class="contact-sub">+32 476 617 104</div>
            <div class="contact-bold">Office</div>
            <div class="contact-sub">
              ICAB buidling, WItte Patersstraat 4, 1040 Brussels
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LandingBar from "../components/Common/LandingBarFSP.vue";
import SummaryChart from "../components/Charts/SummaryChart";
import { mdiScaleBalance, mdiCurrencyEur, mdiRepeat } from "@mdi/js";

export default {
  components: { LandingBar, SummaryChart },
  data() {
    return {
      icons: {
        mdiScaleBalance,
        mdiCurrencyEur,
        mdiRepeat,
      },
      bread: [
        {
          text: "Help",
          disabled: false,
        },
        {
          text: "Support",
          disabled: false,
        },
      ],
    };
  },
  methods: {
    selectAll() {
      let boxes = document.querySelectorAll("input");
      for (let box of boxes) {
        box.checked = true;
      }
    },
    userHistory() {
      this.Apps.userHistory();
    },
    offerHistory() {
      this.Apps.offerHistory();
    },
  },
};
</script>

<style lang="scss">
@import "../sass/main.scss";

.page-container-summary {
  min-height: 100vh;
  background: #f8fcff;
  padding-bottom: 50px;
  margin-top: -100px;
}

.nav-bar {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  margin-top: -100px;
  margin-left: -10px;
}

.buy-wrapper {
  padding: 40px;
  background: #f8fcff;
}

.balance-flex {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-top: 10px;
}

.summary-icon {
  color: #fff !important;
  position: absolute !important;
  top: 20px !important;
  right: 20px !important;
}

.summary-header {
  color: #fff;
}

.balance {
  margin: 20px 0;
  font-size: 1.3em;
  color: #fff;
  font-weight: 700;
}

.conversion {
  font-size: 0.8em;
  color: #999;
}

.summary-upper {
  display: flex;
  justify-content: space-between;
}

.summary-left,
.summary-right {
  width: 48%;
  display: flex;
  flex-direction: column;
}

.help-button {
  margin-bottom: 35px;
  margin: 0 auto;
}

.help-button span {
  color: #fff;
  text-transform: none;
}

.transfer-button {
  margin-bottom: 35px;
  margin-left: auto;
}

.transfer-button span {
  color: #fff;
  text-transform: none;
}

.summary-middle {
  display: flex;
  margin: 60px 0;
}

.summary-graph {
  flex: 1;
  width: 100%;
  position: relative;
  background: rgba(0, 0, 0, 0);
  padding: 0 20px;
  overflow-x: hidden;
}

.summary-middle-table {
  width: 50%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-right: 0;
}

.summary-middle-table table {
  margin: 0;
}

.buy-wrapper table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
}

.buy-wrapper th {
  color: #fff;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 600px;
  padding: 15px;
  text-align: left;
}

.buy-wrapper td {
  color: #4a4a4a;
  font-size: 14px;
  font-weight: 600px;
  padding: 15px;
  text-align: left;
}

.transactions {
  width: 100%;
}

.table-headline2 {
  font-size: 22px;
  color: #000;
  margin-bottom: 20px;
}

.help-subheadline {
  font-size: 20px;
  margin-bottom: 40px;
}

.support-form label {
  display: block;
  font-size: 0.9em;
  margin: 0 0 3px 5px;
  color: #979797;
}

.support-form input,
.support-form textarea {
  width: 100%;
  padding: 12px 10px !important;
  border-radius: 3px;
  border: 1px solid #ccc;
  background: #fff;
  resize: none;
}

.help-button-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.help-button {
  padding: 5px 20px;
}

.chatbox {
  background-color: #fff;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.chatbox-text {
  font-size: 24px;
  margin-bottom: 20px;
}

.divider-row {
  margin: 50px 0 30px 0;
  flex: none !important;
}

.divider-text {
  font-size: 14px;
  padding: 0 20px;
  color: #979797;
  margin-top: -10px;
}

.contact-headline {
    font-size: 22px;
    margin-bottom: 20px;
}

.contact-bold {
    font-size: 22px;
    font-weight: 700;
    margin-top: 20px;
}

.contact-sub {
    font-size: 16px;
}

.green-text {
    color: #59c26d
}
</style>